<script setup lang="ts">
import Loader from '@/components/interface/Loader.vue'
</script>

<template>
  <div class="fixed flex items-center justify-end top-0 pr-10 left-0 w-full h-full z-50 bg-black/5">
    <div>
      <Loader :size="60" :stroke-width="2" />
    </div>
  </div>
</template>
